import React, { useEffect } from 'react';
import './App.css';

const PAGES = {
  '/privacy': {
    title: '개인정보처리방침',
    pageTitle: '개인정보처리방침 | PlayPin',
    lead: 'PlayPin은 회원가입 없이 축제, 행사, 공연, 관광지 정보를 제공하며 서비스 운영에 필요한 최소한의 정보만 처리합니다.',
    sections: [
      {
        title: '수집하는 정보',
        items: [
          '회원가입 기능은 제공하지 않으며 이름, 주민등록번호, 결제정보 같은 직접 식별 정보를 수집하지 않습니다.',
          '서비스 안정성, 보안, 통계 분석을 위해 접속 로그, IP 주소, 브라우저 정보, 기기 정보, 이용 시간, 검색/필터 사용 기록이 자동으로 생성될 수 있습니다.',
          'Google AdSense, Google Analytics 등 광고/분석 도구를 적용하는 경우 쿠키 또는 유사 기술이 사용될 수 있습니다.',
        ],
      },
      {
        title: '이용 목적',
        items: [
          '축제, 행사, 공연, 관광지 검색과 지도 기반 서비스 제공',
          '오류 분석, 서비스 품질 개선, 보안 모니터링',
          '광고 노출, 광고 성과 측정, 방문 통계 분석',
        ],
      },
      {
        title: '보관 및 파기',
        items: [
          '자동 생성 로그는 운영 목적 달성 후 지체 없이 파기하거나 통계 형태로 비식별 처리합니다.',
          '문의 메일로 전달된 정보는 문의 처리와 분쟁 대응에 필요한 기간 동안 보관한 뒤 삭제합니다.',
        ],
      },
      {
        title: '제3자 서비스',
        items: [
          '광고와 통계를 위해 Google 서비스가 사용될 수 있으며, 이 경우 Google의 개인정보 처리방침과 쿠키 정책이 함께 적용될 수 있습니다.',
          '지도, 지오코딩, 공공데이터 API 호출 과정에서 서비스 제공에 필요한 요청 정보가 각 제공기관으로 전달될 수 있습니다.',
        ],
      },
      {
        title: '문의',
        items: [
          '개인정보 관련 문의, 열람/정정/삭제 요청은 문의 페이지의 연락처로 접수할 수 있습니다.',
          '시행일: 2026년 4월 30일',
        ],
      },
    ],
  },
  '/contact': {
    title: '문의 및 운영자 안내',
    pageTitle: '문의 및 운영자 안내 | PlayPin',
    lead: 'PlayPin은 전국 축제, 행사, 공연, 주변 관광 정보를 더 쉽게 찾기 위한 지도 기반 서비스입니다.',
    sections: [
      {
        title: '문의 가능 항목',
        items: [
          '잘못된 축제/행사 정보 제보',
          '종료된 행사, 잘못된 위치, 잘못된 홈페이지 링크 정정 요청',
          '데이터 출처, 저작권, 광고, 제휴 관련 문의',
          '서비스 오류와 접근성 문제 제보',
        ],
      },
      {
        title: '연락처',
        items: [
          '운영자 이메일: playpintrc@gmail.com',
        ],
      },
      {
        title: '정정 요청 안내',
        items: [
          '행사명, 지역, 잘못된 내용, 확인 가능한 공식 URL을 함께 보내주시면 더 빠르게 확인할 수 있습니다.',
          '공공 API 원천 데이터가 잘못된 경우 원 제공기관 반영 시점에 따라 수정까지 시간이 걸릴 수 있습니다.',
        ],
      },
    ],
  },
  '/sources': {
    title: '데이터 출처 안내',
    pageTitle: '데이터 출처 안내 | PlayPin',
    lead: 'PlayPin은 공공 API와 문화기관 공개 데이터를 수집, 정리, 가공하여 지도와 목록 형태로 제공합니다.',
    sections: [
      {
        title: '주요 데이터 출처',
        items: [
          '한국관광공사 TourAPI: 축제, 행사, 관광지, 상세 소개, 이미지, 위치 정보',
          'KOPIS 공연예술통합전산망: 공연시설, 공연, 공연형 축제 정보',
          '서울 열린데이터광장 문화행사정보: 서울시 문화행사 정보',
          '경기데이터드림/경기문화재단: 경기도 문화행사 정보',
          '인천문화재단 OpenAPI: 인천 문화예술행사와 문화기반시설 정보',
          '기타 지자체 및 문화기관 공개 API는 적용 여부 검토 후 순차적으로 추가합니다.',
        ],
      },
      {
        title: '가공 방식',
        items: [
          '출처별 필드를 공통 축제/행사/공연/관광지 형식으로 매핑합니다.',
          '중복 가능성이 높은 데이터는 제목, 장소, 기간, 출처 식별자를 기준으로 정리합니다.',
          '좌표가 없는 데이터는 주소 또는 장소명을 기준으로 지오코딩을 수행할 수 있습니다.',
        ],
      },
      {
        title: '정확성 안내',
        items: [
          '행사 일정, 장소, 요금, 홈페이지 정보는 원 제공기관 사정에 따라 변경될 수 있습니다.',
          '방문 전 공식 홈페이지 또는 주최기관 안내를 반드시 확인하는 것을 권장합니다.',
          '각 상세 페이지 하단에는 가능한 범위에서 데이터 출처와 원문 링크를 표시합니다.',
        ],
      },
      {
        title: '출처 표기 원칙',
        items: [
          '서비스 내 정보 제공 화면에는 기관명, 데이터명, 원문 URL 또는 대표 URL을 표시합니다.',
          '광고나 제휴 콘텐츠와 공공데이터 기반 정보는 구분되도록 운영합니다.',
        ],
      },
    ],
  },
};

function LegalPages() {
  const path = window.location.pathname.replace(/\/index\.html$/, '').replace(/\/$/, '') || '/';
  const page = PAGES[path] || PAGES['/privacy'];

  useEffect(() => {
    const canonicalUrl = `https://playpin.kr${path}`;
    document.title = page.pageTitle;
    setMeta('name', 'description', page.lead);
    setMeta('property', 'og:title', page.pageTitle);
    setMeta('property', 'og:description', page.lead);
    setMeta('property', 'og:url', canonicalUrl);
    setCanonical(canonicalUrl);
  }, [page, path]);

  return (
    <main className="legal-page">
      <nav className="legal-nav">
        <a href="/">PlayPin</a>
        <span />
        <a href="/festivals">축제 목록</a>
        <a href="/privacy">개인정보처리방침</a>
        <a href="/contact">문의</a>
        <a href="/sources">데이터 출처</a>
      </nav>
      <article className="legal-card">
        <header className="legal-header">
          <p>PlayPin 안내</p>
          <h1>{page.title}</h1>
          <strong>{page.lead}</strong>
        </header>
        {page.sections.map(section => (
          <section key={section.title} className="legal-section">
            <h2>{section.title}</h2>
            <ul>
              {section.items.map(item => <li key={item}>{item}</li>)}
            </ul>
          </section>
        ))}
      </article>
    </main>
  );
}

function setMeta(attribute, key, content) {
  let el = document.head.querySelector(`meta[${attribute}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attribute, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

export default LegalPages;
